import { colorLookup } from '@medifind/utils';
import { SVG } from './SVG';

const IconGraduation = ({ size = 12, color }) => {
  const colorCode = colorLookup(color) ?? colorLookup('black');

  return (
    <SVG width={size} height={size} xmlns="http://www.w3.org/2000/svg" fill={colorCode} viewBox="15.5 17.81 77.56 65.02">
      <path
        fill={colorCode}
        d="m58.426 19.73c-4.3672-2.5547-9.7695-2.5547-14.133 0l-25.824 15.098c-4.0625 2.3789-3.9297 8.2969 0.23828 10.492l26.133 13.754c4.082 2.1484 8.957 2.1484 13.039 0l26.133-13.754c0.67188-0.35547 1.2344-0.80078 1.6953-1.3164 0.09375 0.074219 0.14844 0.1875 0.14844 0.30859v17.758c0 1.9883 1.6133 3.6016 3.6016 3.6016s3.5977-1.6133 3.5977-3.6016v-17.758c0-2.6992-1.4297-5.1953-3.7617-6.5586l-17.066-9.9805c-0.12109-0.070313-0.24609-0.13281-0.36719-0.1875zm-31.793 36.039v14.359c0 0.73438 0.40234 1.4062 1.043 1.7578l16.988 9.2461c4.1758 2.2734 9.2148 2.2734 13.391 0l16.984-9.2461c0.64453-0.35156 1.0469-1.0234 1.0469-1.7578v-14.195l-18.91 10.066c-3.5195 1.875-7.7422 1.8789-11.266 0.007812z"
        fillRule="evenodd"
      />
    </SVG>
  );
};

export { IconGraduation as default, IconGraduation };
